import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDom from 'react-dom';
import Page from '../shared/components/Page';
import { configureClientInstrumentation } from './lib/client-instrumentation';
import { attachAnalyticsListeners } from '@spotify-internal/touchdown-analytics';

if (window.SPOTI_DATA.useInstrumentation) {
  configureClientInstrumentation();
}

const baseElement = document.getElementById('spoti-root');
ReactDom.hydrate(<Page {...window.SPOTI_DATA} />, baseElement);

const isAuthenticated = window.SPOTI_DATA.user.authenticated || false;
const pageName = window.SPOTI_DATA.pageName || '';
const countryCode = window.SPOTI_DATA.country || '';
const eventParams = window.SPOTI_DATA.pageData.eventParams || {};

attachAnalyticsListeners({
  analyticsRoot: baseElement!,
  isAuthenticated,
  pageName,
  countryCode,
  eventParams,
});
